<div class="row arbetsorder-restriktioner-row">
    <rask-action-button class="col-4"
        aid="buttonAddRestriktion"
        [options]="restriktionsTyper"
        alignment="left"
        icon="far fa-plus"
        [showChevron]="false"
        (optionSelected)="addRestriktion($event)">Lägg till ny</rask-action-button>
</div>
<rask-cards>
    @for(restriktion of arbetsorder.restriktioner; track restriktion.id; let index = $index) {
    <rask-card [label]="getTypText(restriktion.typ)" [headerIcon]="getIcon(restriktion.status)"
        [headerIconDisabled]="restriktionIsDisabled(restriktion)" [size]="4"
        intent="delete" (iconClick)="deleteRestriktion(restriktion)">
        <rask-selector
            aid="restriktionsStatus"
            class="col-4"
            (ngModelChange)="UpdateRestriktionSatus(restriktion, $event)"
            [ngModel]="restriktion.status"
            [values]="statusar">
        </rask-selector>
        <rask-button color="secondary" (click)="openAnteckningar(restriktion)" [disabled]="!restriktion.id">Anteckningar</rask-button>
    </rask-card>
    }
</rask-cards>